import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, assetUrl, getGuest } from "@/lib/api";
import { SiteFooter } from "@/components/Chrome";

export default function MyProperties() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!getGuest()) return setItems([]);
    api.get("/me/properties").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <main data-testid="my-properties-page">
      <div className="mx-auto max-w-5xl px-5 pt-12 sm:px-8">
        <div className="eyebrow mb-3">Saved on this device</div>
        <h1 className="font-display text-4xl tracking-tight sm:text-5xl">My properties</h1>
        {items === null && <div className="mt-12 h-40 rounded bg-[var(--bone-2)] shimmer" />}
        {items?.length === 0 && (
          <div className="mt-12 border-t border-[var(--charcoal)]/15 py-12" data-testid="my-properties-empty">
            <p className="font-display text-2xl">No saved properties yet. Start by importing a Zillow URL or uploading photos.</p>
            <button className="btn-primary mt-6" onClick={() => nav("/#import")} data-testid="my-properties-start-button">Start a Project</button>
          </div>
        )}
        <ul className="mt-10 divide-y divide-[var(--line)] border-y border-[var(--line)]" data-testid="my-properties-list">
          {items?.map((p) => (
            <li key={p.id}>
              <Link to={`/p/${p.id}`} data-testid={`my-property-${p.id}`} className="group flex items-center gap-4 py-5 sm:gap-6">
                <div className="h-20 w-28 shrink-0 overflow-hidden rounded-xl bg-[var(--sand)] sm:h-24 sm:w-36">
                  {p.coverUrl && <img src={assetUrl(p.coverUrl)} alt="" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="truncate font-display text-xl sm:text-2xl" data-testid={`my-property-title-${p.id}`}>{p.title}</div>
                  <div className="mt-1 text-xs text-[var(--stone-dark)]">
                    {p.photoCount} photo{p.photoCount === 1 ? "" : "s"} · {p.visionCount} vision{p.visionCount === 1 ? "" : "s"}
                    {p.style ? ` · ${p.style}` : ""}
                  </div>
                </div>
                <span className="text-[var(--stone-dark)] transition-transform duration-300 group-hover:translate-x-1">→</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <SiteFooter />
    </main>
  );
}
